<template>
  <div class="internal-history-listing" v-if="getPermission('history:view')">
    <v-container fluid class="custom-bthrust-style">
      <v-container class="pr-0">
        <v-layout class="justify-end">
          <div class="mx-2 my-2">
            <v-menu
              v-if="false"
              v-model="datePicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  filled
                  flat
                  placeholder="Date Range"
                  hide-details
                  solo
                  :disabled="pageLoading"
                  v-on:click:clear="clearFilter('dates')"
                  clearable
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :value="formattedDate"
                  color="cyan"
                ></v-text-field>
              </template>
              <v-date-picker
                color="cyan"
                range
                :disabled="pageLoading"
                v-on:change="getHistories"
                v-model="dates"
              ></v-date-picker>
            </v-menu>
            <DateRangePicker
              placeholder="Data Range"
              v-model="dates"
              v-on:update:model-value="getHistories()"
              v-on:click:clear="clearFilter('dates')"
            ></DateRangePicker>
          </div>
          <div class="mr-2 my-2">
            <v-text-field
              v-model.trim="filter.search"
              v-on:click:clear="clearFilter('search')"
              clearable
              dense
              filled
              flat
              placeholder="Search"
              hide-details
              solo
              :disabled="pageLoading"
              color="cyan"
              @keydown.enter="getHistories"
              @keydown.tab="getHistories"
            ></v-text-field>
          </div>
          <div class="ml-2 my-2">
            <v-tooltip bottom content-class="custom-bottom-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  class="custom-bold-button white--text"
                  color="cyan"
                  tile
                  :disabled="pageLoading"
                  v-on:click="getHistories"
                >
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>Search</span>
            </v-tooltip>
          </div>
          <div class="ml-2 my-2" v-if="!internal">
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="type === 'visit' || type === 'project'"
                  :disabled="pageLoading"
                  :loading="pageLoading"
                  depressed
                  class="mx-2 custom-bold-button"
                  color="cyan white--text"
                  v-on:click="exportHistory"
                >
                  <v-icon dark left>mdi-database-export</v-icon> Export
                </v-btn>
              </template>
            </v-menu>
          </div>
        </v-layout>
      </v-container>
      <v-simple-table fixed-header height="70vh">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="simple-table-th">Description</th>
              <th width="200" class="simple-table-th text-center">
                IP Address
              </th>
              <th width="200" class="simple-table-th">Created Time</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="histories.length > 0">
              <tr
                v-for="(history, index) in histories"
                :key="index"
                :class="{
                  'custom-border-top': index == 0,
                  'orange_lighten-5': index % 2 == 0,
                }"
              >
                <td class="simple-table-td">
                  <template v-if="history.added_by">
                    <span class="font-weight-700">{{
                      history.added_by.display_name
                    }}</span>
                  </template>
                  <!-- <span v-html="history.description"></span> -->
                  <read-more
                    class="desc-mb"
                    more-str="Read more"
                    :text="history.description || '<em>No description</em>'"
                    link="#"
                    less-str="Read less"
                    :max-chars="150"
                  >
                  </read-more>
                </td>

                <td
                  class="simple-table-td"
                  width="200"
                  style="text-align: center"
                >
                  {{ history.ip_address }}
                </td>
                <td class="simple-table-td" width="200">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        v-if="history.created_at"
                        class="mx-2 my-1 custom-grey-border"
                        color="cyan darken-1"
                        text-color="white"
                        label
                        small
                        v-bind="attrs"
                        v-on="on"
                      >
                        <!-- <v-avatar left>
                          <v-icon>mdi-clock-outline</v-icon>
                        </v-avatar> -->
                        <p class="m-0 custom-nowrap-ellipsis">
                          {{ history.created_at }}
                        </p>
                      </v-chip>
                    </template>
                    <p class="m-0 custom-nowrap-ellipsis">
                      {{ formatDate(history.added_at) }}
                      {{ formatDateStartedNew(history.added_at) }}
                    </p>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-else>
              <template v-if="pageLoading">
                <tr v-for="row in 3" :key="row">
                  <td>
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                  <td>
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                  <td>
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                  <td v-if="type == 'quotation'">
                    <v-skeleton-loader
                      type="text"
                      class="custom-skeleton table-rows-text"
                    ></v-skeleton-loader>
                  </td>
                </tr>
              </template>
              <tr v-else-if="!pageLoading">
                <td colspan="4">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    Uhh... There are no history at the moment.
                  </p>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      <ListingFooter
        :dataLoading="pageLoading"
        :currentPage="current_page"
        :totalPages="total_pages"
        :showingFrom="showingFrom"
        :showingTo="showingTo"
        :totalRows="total_rows"
        removePage
      ></ListingFooter>
    </v-container>
    <Dialog :commonDialog="historyModal">
      <template v-slot:title> Remark </template>
      <template v-slot:body>
        <v-row>
          <v-col md="12" class="p-5 pl-5 pr-5">
            {{ historyRemark }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:action>
        <v-btn
          :disabled="pageLoading"
          class="mx-2 custom-red-border custom-bold-button red white--text"
          v-on:click="historyModal = false"
        >
          Close
        </v-btn>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import DateRangePicker from "@/view/components/DateRangePicker";
import moment from "moment-timezone";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import Dialog from "@/view/pages/partials/Dialog.vue";
import JwtService from "@/core/services/jwt.service";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      dates: [],
      pageLoading: false,
      histories: new Array(),
      filter: {
        search: null,
      },
      per_page: 10,
      current_page: 1,
      offset: 0,
      total_pages: 0,
      total_rows: 0,
      historyRemark: null,
      historyModal: false,
    };
  },
  components: {
    ListingFooter,
    Dialog,
    DateRangePicker,
  },
  props: {
    isCurrentUser: {
      required: false,
      type: Number,
      default: 0,
    },
    type: {
      required: true,
      type: String,
      default: "",
    },
    type_id: {
      required: false,
      type: Number,
      default: 0,
    },
    internal: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    type_id() {
      let type_id = this.lodash.toSafeInteger(this.type_id);
      if (type_id > 0) {
        this.getHistories();
      }
    },
  },
  methods: {
    exportHistory() {
      const { query } = this.$route;
      let downloadURL = process.env.VUE_APP_API_URL + "history/export";
      downloadURL = new URL(downloadURL);

      const token = JwtService.getToken();
      downloadURL.searchParams.append("token", token);
      if (query) {
        this.lodash.map(query, (row, index) => {
          if (row) {
            downloadURL.searchParams.append(`${index}`, row);
          }
        });
      }
      if (this.filter.search) {
        downloadURL.searchParams.set("search", this.filter.search);
      }
      if (this.dates && this.dates[0] && this.dates[1]) {
        downloadURL.searchParams.set("start_date", this.dates[0]);
        downloadURL.searchParams.set("end_date", this.dates[1]);
      }
      downloadURL.searchParams.set("type", this.type);
      downloadURL.searchParams.set("type_id", this.type_id);
      // console.log("FINAL EXPORT URL:", downloadURL);

      window.open(downloadURL, "_blank");
    },
    openRemarkHistory(history) {
      let _this = this;
      _this.historyRemark = history?.remark;
      _this.historyModal = true;
    },
    formatDateStartedNew(param) {
      return moment(param).format("hh:mm A");
    },
    clearFilter(field) {
      const _this = this;
      switch (field) {
        case "search":
          _this.filter.search = null;
          break;
        case "dates":
          _this.dates = [];
          break;
      }
      _this.getHistories();
    },
    getHistories() {
      const _this = this;

      if (_this.lodash.isEmpty(_this.dates) === false) {
        if (moment(_this.dates[0]).isAfter(_this.dates[1])) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("End Date must be after Start Date.")
          );
          return false;
        }
      }
      _this.pageLoading = true;
      _this.histories = [];
      _this.$store
        .dispatch(QUERY, {
          url: "history",
          data: {
            type: _this.type,
            type_id: _this.type_id,
            per_page: _this.per_page,
            current_page: _this.current_page,
            search: _this.filter.search,
            start_date: _this.dates[0] || null,
            end_date: _this.dates[1] || null,
            is_current_user: _this.isCurrentUser,
          },
        })
        .then(({ data }) => {
          _this.offset = data.offset;
          _this.histories = data.rows;
          _this.total_pages = Math.ceil(data.total_rows / data.per_page);
          _this.current_page = data.current_page;
          _this.total_rows = data.total_rows;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },
  mounted() {
    const _this = this;
    /* let type_id = _this.lodash.toSafeInteger(_this.type_id);
    if (type_id > 0) {
      _this.getHistories();
    } */
    _this.getHistories();

    PaginationEventBus.$on("update:pagination", (param) => {
      _this.current_page = param;
      _this.getHistories();
    });
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.histories) === false
        ? this.offset + 1
        : 0;
    },
    showingTo() {
      return this.offset + (this.histories ? this.histories.length : 0);
    },
  },
};
</script>
